import { FileText } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types/PickerTypes";

interface ApiDataItemProps extends PickerItemProps {
  displayField: string;
  valueField: string;
  secondaryField?: string;
  iconField?: string;
}

export const ApiDataItem = ({
  item,
  isSelected,
  onSelect,
  displayField,
  secondaryField,
  iconField,
}: ApiDataItemProps) => {
  // Get the display value safely
  const primaryText = item[displayField] || item.name || item.label || 'Unknown';
  const secondaryText = secondaryField ? item[secondaryField] : null;
  const iconName = iconField ? item[iconField] : null;

  // Default icon based on common patterns
  const getDefaultIcon = () => {
    if (primaryText.toLowerCase().includes('contract')) return FileText;
    if (primaryText.toLowerCase().includes('huur')) return FileText;
    return FileText;
  };

  const IconComponent = iconName ? FileText : getDefaultIcon(); // Could extend this to dynamically import icons

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full p-3 text-left border rounded-lg transition-all duration-200 ${
        isSelected
          ? "border-brick-primary bg-brick-secondary-fine shadow-md"
          : "border-neutral-primary/10 hover:border-brick-primary/30 hover:bg-brick-secondary-fine/30"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className={`shrink-0 ${isSelected ? "text-brick-primary" : "text-neutral-secondary-mid"}`}>
          <IconComponent className="w-5 h-5" />
        </div>

        <div className="flex-1 min-w-0">
          <div className={`font-medium text-sm ${isSelected ? "text-brick-primary" : "text-neutral-primary"}`}>
            {primaryText}
          </div>

          {secondaryText && (
            <div className="text-xs text-neutral-secondary-mid mt-1 truncate">
              {secondaryText}
            </div>
          )}
        </div>

        {isSelected && (
          <div className="shrink-0">
            <div className="w-2 h-2 bg-brick-primary rounded-full"></div>
          </div>
        )}
      </div>
    </button>
  );
};